"use strict";
/*
 * Created on 2019-07-15
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var CompetitorReferentialPriceConverter_1 = require("../../price-calculation/conversions/CompetitorReferentialPriceConverter");

var CompetitorPriceChangeReportDTO_1 = require("../model/CompetitorPriceChangeReportDTO");

var CompetitorPriceChangeReportDTOConverter_1 = require("./CompetitorPriceChangeReportDTOConverter");
/**
 * @author JMr
 */


var CompetitorPriceChangeReportDTOConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceChang) {
  _inherits(CompetitorPriceChangeReportDTOConverterImpl, _CompetitorPriceChang);

  function CompetitorPriceChangeReportDTOConverterImpl(competitorReferentialPriceConverter) {
    var _this;

    _classCallCheck(this, CompetitorPriceChangeReportDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportDTOConverterImpl).call(this));
    _this.competitorReferentialPriceConverter = competitorReferentialPriceConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorPriceChangeReportDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new CompetitorPriceChangeReportDTO_1.CompetitorPriceChangeReportDTO(CompetitorPriceChangeReportDTO_1.CompetitorPriceChangeReportDTO.schema.competitorId.valueOf(source.competitorId), CompetitorPriceChangeReportDTO_1.CompetitorPriceChangeReportDTO.schema.competitorName.valueOf(source.competitorName), conversions.asObjectList(source, 'prices', function (doc) {
        return _this2.competitorReferentialPriceConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {
        competitorId: source.competitorId,
        competitorName: source.competitorName,
        prices: conversions.asObjectArray(source, 'prices', function (price) {
          return _this3.competitorReferentialPriceConverter.toDocument(price, conversions);
        })
      };
      return result;
    }
  }]);

  return CompetitorPriceChangeReportDTOConverterImpl;
}(CompetitorPriceChangeReportDTOConverter_1.CompetitorPriceChangeReportDTOConverter);

CompetitorPriceChangeReportDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CompetitorReferentialPriceConverter_1.CompetitorReferentialPriceConverter])], CompetitorPriceChangeReportDTOConverterImpl);
exports.CompetitorPriceChangeReportDTOConverterImpl = CompetitorPriceChangeReportDTOConverterImpl;